import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import '../../styles-bi-select.css';

/**
 * BIPagination
 * Componente unificado e moderno de paginação com seletor de linhas por página estilizado.
 */
export default function BIPagination({
  page = 1,
  perPage = 50,
  total = 0,
  onPageChange,
  onPerPageChange,
  perPageOptions = [10, 25, 50, 100, 200],
  itemLabel = 'registros',
  className = '',
  style = {}
}) {
  if (!total || total <= 0) return null;

  const totalPages = Math.ceil(total / perPage) || 1;
  const startItem = Math.min(((page - 1) * perPage) + 1, total);
  const endItem = Math.min(page * perPage, total);

  // Geração inteligente de páginas
  const getPageNumbers = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (page <= 4) {
      return [1, 2, 3, 4, 5, '...', totalPages];
    }
    if (page >= totalPages - 3) {
      return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    return [1, '...', page - 1, page, page + 1, '...', totalPages];
  };

  const pages = getPageNumbers();

  return (
    <div className={`bi-pagination-container ${className}`} style={style}>
      {/* Informações de Contagem e Seletor de Linhas */}
      <div className="bi-pagination-info">
        <span className="bi-pagination-count">
          Mostrando <strong>{startItem}</strong>-<strong>{endItem}</strong> de <strong>{total}</strong> {itemLabel}
        </span>

        {onPerPageChange && (
          <div className="bi-pagination-per-page">
            <span className="bi-pagination-per-page-label">
              Linhas por pág.:
            </span>
            <select
              className="bi-pagination-select"
              value={perPage}
              onChange={(e) => onPerPageChange(Number(e.target.value))}
              aria-label="Linhas por página"
            >
              {perPageOptions.map((opt) => (
                <option key={opt} value={opt}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* Botões de Navegação */}
      <div className="bi-pagination-nav">
        <button
          type="button"
          className="bi-pagination-btn bi-pagination-prev"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          title="Página anterior"
        >
          <FiChevronLeft size={14} style={{ marginRight: '3px' }} />
          <span>Anterior</span>
        </button>

        {pages.map((p, idx) => {
          if (p === '...') {
            return (
              <span key={`dots-${idx}`} className="bi-pagination-ellipsis">
                …
              </span>
            );
          }
          const isCurrent = p === page;
          return (
            <button
              key={p}
              type="button"
              className={`bi-pagination-btn bi-pagination-num ${isCurrent ? 'active' : ''}`}
              onClick={() => {
                if (!isCurrent) onPageChange(p);
              }}
              aria-current={isCurrent ? 'page' : undefined}
              title={`Página ${p}`}
              style={isCurrent ? {
                backgroundColor: '#2563eb',
                borderColor: '#1d4ed8',
                color: '#ffffff',
                fontWeight: 700,
                boxShadow: '0 2px 6px rgba(37,99,235,0.4)'
              } : undefined}
            >
              {p}
            </button>
          );
        })}

        <button
          type="button"
          className="bi-pagination-btn bi-pagination-next"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          title="Próxima página"
        >
          <span>Próximo</span>
          <FiChevronRight size={14} style={{ marginLeft: '3px' }} />
        </button>
      </div>
    </div>
  );
}
